import {
  H_08,
  HERO_DEFAULTS,
  hideH08Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const H08_PLASMIC_PROPS = {
  heading: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_08].heading,
    description: "Main heading (H08 only)",
    hidden: hideH08Props,
  },
  description: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_08].description,
    description: "Description text (H08 only)",
    hidden: hideH08Props,
  },
  summaryDescription: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_08].summaryDescription,
    description: "Summary description text (H08 only)",
    hidden: hideH08Props,
  },
  teamTitle: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_08].teamTitle,
    description: "Team title (H08 only)",
    hidden: hideH08Props,
  },
  teamDate: {
    type: "dateString",
    description: "Team date (H08 only)",
    hidden: hideH08Props,
  },
  teamDateFormat: {
    type: "string",
    defaultValue: "Do MMM YYYY",
    description: "Date format for team date (H08 only)",
    hidden: hideH08Props,
  },
  testimonialHeading: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_08].testimonialHeading,
    description: "Testimonial heading (H08 only)",
    hidden: hideH08Props,
  },
  badgeLogo: {
    type: "object",
    fields: {
      image: { type: "imageUrl", defaultValue: "" },
      alt: { type: "string", defaultValue: "" },
    },
    defaultValue: HERO_DEFAULTS[H_08].badgeLogo,
    description: "Badge logo (H08 only)",
    hidden: hideH08Props,
  },
  heroImage: {
    type: "object",
    fields: {
      image: {
        type: "imageUrl",
        defaultValue: "https://cdn.bystadium.com/plasmic/static-slices/b09-desktop-img.png",
      },
      alt: { type: "string", defaultValue: "" },
    },
    defaultValue: HERO_DEFAULTS[H_08].image,
    description: "Hero image (H08 only)",
    hidden: hideH08Props,
  },
  testimonialAuthorName: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_08].testimonial.testimonialAuthorName,
    description: "Testimonial author name (H08 only)",
    hidden: hideH08Props,
  },
  testimonialAuthorImage: {
    type: "object",
    fields: {
      image: { type: "imageUrl", defaultValue: "" },
      alt: { type: "string", defaultValue: "" },
    },
    defaultValue: HERO_DEFAULTS[H_08].testimonial.testimonialAuthorImage,
    description: "Testimonial author image (H08 only)",
    hidden: hideH08Props,
  },
  testimonialAuthorCompanyLogo: {
    type: "object",
    fields: {
      image: { type: "imageUrl", defaultValue: "" },
      alt: { type: "string", defaultValue: "" },
    },
    defaultValue: HERO_DEFAULTS[H_08].testimonial.testimonialAuthorCompanyLogo,
    description: "Testimonial company logo (H08 only)",
    hidden: hideH08Props,
  },
};
